{
  "version": 1,
  "asset_id": "15222a7f-ba1e-4563-a862-55322d74e8f6",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/15222a7f-ba1e-4563-a862-55322d74e8f6/cert-lsqa.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/15222a7f-ba1e-4563-a862-55322d74e8f6/cert-lsqa.png",
  "original_filename": "cert-lsqa.png",
  "size": 10185,
  "content_type": "image/png",
  "created_at": "2026-07-13T04:09:58Z"
}
